// extracted by mini-css-extract-plugin
module.exports = {"root":"HoverCard_root__3rRcR","inside":"HoverCard_inside__3BnsD","disabled":"HoverCard_disabled__3G-9-","loader":"HoverCard_loader__3MsJ0"};